import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const StyledAutocompleteContainer = styled("div")`
    @media (min-width: ${breakpoints.values.lg}px) {
        pointer-events: initial;
        position: absolute;
        width: 100%;
        background: ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.backgroundColor};
    }
`
